var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div'), _c('div', {
    staticClass: "top",
    on: {
      "click": _vm.backClick
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "listTop"
  }, [_vm._v("待审核话术：" + _vm._s(_vm.list.length) + "条")]), _c('div', {
    staticClass: "list"
  }, _vm._l(_vm.list, function (item, idx) {
    return _c('div', {
      key: item.id,
      staticClass: "listItem"
    }, [_c('div', {
      staticClass: "listItemT"
    }, [_c('img', {
      staticClass: "listItemTL",
      attrs: {
        "src": item.faceIcon
      }
    }), _c('div', {
      staticClass: "listItemTM"
    }, [_vm._v(_vm._s(item.nickname))]), item.type == 1 ? _c('div', {
      staticClass: "listItemTR"
    }, [_vm._v(" 新增话术 ")]) : item.type == 2 ? _c('div', {
      staticClass: "listItemTR listItemTR2"
    }, [_vm._v(" 修改话术 ")]) : _vm._e()]), _c('div', {
      staticClass: "listItemT2"
    }, [_c('img', {
      attrs: {
        "src": "https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"
      }
    }), _vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      staticClass: "listItemT3"
    }), _c('pre', {
      staticClass: "listItemT4",
      domProps: {
        "innerHTML": _vm._s(item.newSpeechText)
      }
    }), _c('div', {
      staticClass: "listItemB"
    }, [_c('div', {
      staticClass: "listItemBL"
    }, [_vm._v("分类：" + _vm._s(item.labelName))]), _c('div', {
      staticClass: "listItemBR"
    }, [_c('div', {
      staticClass: "listItemBBtn red",
      on: {
        "click": function ($event) {
          return _vm.refuseClick(idx);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250821182438.png"
      }
    }), _c('div', [_vm._v("拒绝")])]), _c('div', {
      staticClass: "listItemBBtn blue",
      on: {
        "click": function ($event) {
          return _vm.modifyClick(idx);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250821182549.png"
      }
    }), _c('div', [_vm._v("修改")])]), _c('div', {
      staticClass: "listItemBBtn green",
      on: {
        "click": function ($event) {
          return _vm.agreeClick(idx);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250821182604.png"
      }
    }), _c('div', [_vm._v("通过")])])])])]);
  }), 0), _vm.huashuEditShow ? _c('div', {
    staticClass: "huashuEditDialogCover"
  }, [_c('div', {
    staticClass: "huashuEditDialogCoverMain"
  }, [_c('huashu-edit', {
    attrs: {
      "isWeb": true,
      "labelIdProps": _vm.currentItem.labelId,
      "speechIdProps": _vm.currentItem.speechId,
      "checkId": _vm.currentItem.checkId
    },
    on: {
      "huashuEditClose": _vm.huashuEditClose,
      "huashuEditSuccess": _vm.huashuEditSuccess
    }
  })], 1)]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "topSub"
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.edujia.com/A-1ed71af7_20230804162525.png",
      "crossorigin": "Anonymous"
    }
  }), _c('div', [_vm._v("返回")])]);
}];
export { render, staticRenderFns };